

import React from "react";
import { Card, Col, Descriptions, Row, Table, Typography } from "antd";
import dayjs from "dayjs";
import classes from "../../../Etablissements/Etablissements.module.css";
import { useTranslation } from "react-i18next";
const { Title } = Typography;

const EtapeRecapitulatifFNH = ({ globalData,typesession }) => {
    const { t, i18n } = useTranslation();
  const values = globalData

  const apprenants = values?.apprenants || [];

  const generalDataNonHomologuee  = [
    {
      label: "Secteur",
      value: values?.secteur || "-",
    },
    {
      label: "Sous-secteur",
      value: values?.sous_secteur || "-",
    },
    {
      label: "Domaine",
      value: values?.domaine || "-",
    },
    {
      label: "Date de début de la session de formation",
      value: values?.date_debut_session_formation || "-",
    },
    {
      label: "Date de fin de la session de formation",
      value: values?.date_fin_session_formation || "-",
    },
    {
      label: "Lieu de la formation",
      value: values?.lieu_formation || "-",
    },
    {
      label: "Formateurs",
      value: values?.formateurs?.join(", ") || "-",
    },
    {
      label: "Nombre des apprenants",
      value: values?.nb_apprenants || "-",
    },
  ];

  const generalDataContinue = [
    {
      label: "Secteur",
      value: values?.secteur || "-",
    },
   
    {
      label: "Domaine",
      value: values?.domaine || "-",
    },

    {
      label: "Date de début de la session de formation",
      value: values?.date_debut_session_formation || "-",
    },
    {
      label: "Date de fin de la session de formation",
      value: values?.date_fin_session_formation || "-",
    },

    {
      label: "Lieu de la formation",
      value: values?.lieu_formation || "-",
    },
    {
      label: "Gouvernorat",
      value: values?.gouvernorat || "-",
    },
    {
      label: "Droit de tirage",
      value: values?.droit_tirage || "-",
    },
    {
      label: "Crédit d'impôt",
      value: values?.credit_impot || "-",
    },

    {
      label: "Formateurs",
      value: values?.formateurs?.join(", ") || "-",
    },
    {
      label: "Nombre des apprenants",
      value: values?.nb_apprenants || "-",
    },
  ];

  const columns = [
    {
      title: "Type",
      dataIndex: "typeIdentifiant",
    },
    {
      title: "Nom",
      dataIndex: "nom",
    },
    {
      title: "Prénom",
      dataIndex: "prenom",
    },
    {
      title: "Identifiant",
      dataIndex: "identifiant",
    },
    {
      title: "Date Naissance",
      dataIndex: "dateNaissance",
      render: (value) => value || "-",
    },
    {
      title: "Structure",
      dataIndex: "structure",
    },
    {
      title: "Niveau",
      dataIndex: "niveau",
    },
  ];

  return (

    <Row className={classes.listeRow}>
          <Card
        className={classes.listeCard}
        style={{ marginBottom: "40px" }}
        bordered={false}
        title={
          <div       style={{ textAlign: i18n?.dir() === "ltr" ? "left" : "right" ,   fontSize:"18px",
            fontWeight:"600",
             color:"#195a99",
             marginTop:"20px"
              }}>
            {t("Informations de la Formation")}
          </div>
        }
        
      >

        <Descriptions column={2} layout="vertical" size="small" bordered>
          
        {(typesession === "non_homologuee" ? generalDataNonHomologuee : generalDataContinue)?.map((item, index) => (
            <Descriptions.Item label={item?.label} key={index}>
              {item?.value}
            </Descriptions.Item>
          ))}
        </Descriptions>

        
        
      </Card>

    <Card
        className={classes.listeCard}
        style={{ marginBottom: "40px" }}
        bordered={false}
        title={
          <div       style={{ textAlign: i18n?.dir() === "ltr" ? "left" : "right" ,   fontSize:"18px",
            fontWeight:"600",
             color:"#195a99",
             marginTop:"20px"
              }}>
            {t("Liste des Participants")}
          </div>
        }
    
        
      >
      <Table
        dataSource={apprenants.map((item, index) => ({ ...item, key: index }))}
        columns={columns}
        pagination={false}
        // bordered
        scroll={{ x: "max-content" }}
      />
        
      </Card>
   
   
    </Row>

   
  );
};

export default EtapeRecapitulatifFNH;
